export default __webpack_public_path__ + "static/media/pc.3417a444.gif";